var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4566_1106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.679 221.34C342.965 235.153 348.679 240.122 354.501 245.175C358.233 248.415 363.762 248.416 367.494 245.176C373.322 240.115 381.673 232.898 399.804 217.693C446.942 178.112 481 149.533 481 107.317C481 67.2972 451.601 35.9502 414.071 35.9502C388.861 35.9502 372.133 50.1742 361.63 64.6612C351.684 50.1302 335.512 35.9502 310.229 35.9502C272.7 35.9502 243.315 67.2982 243.315 107.317C243.314 150.603 276.479 178.742 326.679 221.34Z",
    fill: "#9CA37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8 467.949C125.1 441.25 168.101 431.048 214.901 438.849L289.901 451.749C318.702 456.55 345.1 455.049 367.9 447.549C415.068 431.829 462.287 382.32 474.801 363.549C492.202 337.449 501.761 308.949 507.762 295.15C513.462 281.95 513.462 272.65 507.462 267.25C500.561 260.949 488.862 264.249 480.161 269.05C466.362 276.85 451.701 299.35 436.701 320.949C417.202 349.149 383.802 365.949 349.601 365.949H241V335.949H286C365.799 335.949 401.499 320.949 401.499 305.949C401.499 293.35 376.6 287.649 368.199 285.85C335.5 278.35 261.699 274.75 211.3 252.25C202.211 248.273 191.907 246.041 181.002 245.949C163.904 245.804 145.322 251.131 127.599 264.849C127.301 264.849 127.301 264.849 127 265.149C115.3 274.149 99.3 287.349 77.7 306.249C59.399 322.448 41.7 343.148 10.799 369.549C4.72988 374.775 3.77431 383.821 8.61757 390.2L65.0447 464.519C69.9569 470.988 79.0674 472.494 85.8 467.949Z",
    fill: "#9CA37F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4566_1106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.13c05a54560eeea3083e68d38ceea40c.svg";
export { ForwardRef as ReactComponent };